module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Scrollbars</span></div>\r\n<div class=\"row prop-detail\">\r\n	<div class=\"row\">\r\n		<div class=\"col-md-6 form-group-flex\">\r\n			<input type=\"checkbox\" name=\"verticalScroll\" class=\"form-radio-group\" />\r\n			<label class=\"form-group-label\">Vertical</label>\r\n		</div>\r\n		<div class=\"col-md-6 form-group-flex\">\r\n			<input type=\"checkbox\" name=\"horizontalScroll\" class=\"form-radio-group\"/> \r\n			<label class=\"form-group-label\">Horizontal</label>\r\n		</div>\r\n	</div>\r\n</div>")
  }
  return __output;

}